import React from 'react';
import LocationIndex from './_components/LocationIndex';

const Location = () => {
    return (
        <>
            <LocationIndex />
        </>
    );
};

export default Location;
